import { debugFlagActions } from '../actions';
export const INIT_STATE = { settings: null, isLoaded: false };
export function debugFlagsReducer(state = INIT_STATE, action) {
    switch (action.type) {
        case debugFlagActions.ActionTypes.LoadDebugFlagsSuccess:
        case debugFlagActions.ActionTypes.SetDebugFlags:
            return { ...state, settings: action.payload, isLoaded: true };
        case debugFlagActions.ActionTypes.LoadDebugFlags: {
            return state;
        }
        default:
            return state;
    }
}
//# sourceMappingURL=debug-flag.reducer.js.map